"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Functions = require("../core/Functions");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UICopyButton = _interopRequireDefault(require("../button/UICopyButton"));

var _UITextInput = _interopRequireDefault(require("../input/UITextInput"));

var _UIMediaBody = _interopRequireDefault(require("../layout/UIMediaBody"));

var _UIMediaObject = _interopRequireDefault(require("../layout/UIMediaObject"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _sizes = require("HubStyleTokens/sizes");

var _FieldsetContext = require("../context/FieldsetContext");

var ElevatedMediaBody = (0, _styledComponents.default)(_UIMediaBody.default).withConfig({
  displayName: "UICopyInput__ElevatedMediaBody",
  componentId: "dcc8c1-0"
})(["z-index:", ";"], _sizes.MERCURY_LAYER);

var UICopyInput = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UICopyInput, _PureComponent);

  function UICopyInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UICopyInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UICopyInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleCopyClick = function (evt) {
      var _this$props = _this.props,
          onCopy = _this$props.onCopy,
          inputRef = _this$props.inputRef;
      if (inputRef.current) inputRef.current.select();
      (0, _Functions.callIfPossible)(onCopy, evt);
    };

    _this.handleInputMouseDown = function (evt) {
      var _this$props2 = _this.props,
          autoSelect = _this$props2.autoSelect,
          inputRef = _this$props2.inputRef;

      if (autoSelect) {
        evt.preventDefault();
        if (inputRef.current) inputRef.current.select();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UICopyInput, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          __autoSelect = _this$props3.autoSelect,
          buttonProps = _this$props3.buttonProps,
          className = _this$props3.className,
          error = _this$props3.error,
          inputProps = _this$props3.inputProps,
          inputRef = _this$props3.inputRef,
          onChange = _this$props3.onChange,
          __onCopy = _this$props3.onCopy,
          tooltipPlacement = _this$props3.tooltipPlacement,
          value = _this$props3.value,
          valueWhenCopied = _this$props3.valueWhenCopied,
          props = (0, _objectWithoutProperties2.default)(_this$props3, ["autoSelect", "buttonProps", "className", "error", "inputProps", "inputRef", "onChange", "onCopy", "tooltipPlacement", "value", "valueWhenCopied"]);
      var fieldSize = this.context.size;
      return _react.default.createElement(_UIMediaObject.default, Object.assign({}, props, {
        className: (0, _classnames.default)('input-group', 'private-form__group', className),
        spacing: "none",
        MediaBody: ElevatedMediaBody,
        itemRight: _react.default.createElement(_UICopyButton.default, Object.assign({
          className: (0, _classnames.default)('input-group-addon private-form__group--end', buttonProps ? buttonProps.className : undefined),
          onClick: this.handleCopyClick,
          size: fieldSize,
          tooltipPlacement: tooltipPlacement,
          value: value,
          valueWhenCopied: valueWhenCopied
        }, buttonProps))
      }), _react.default.createElement(_UITextInput.default, Object.assign({
        className: (0, _classnames.default)('private-form__group--start', inputProps ? inputProps.className : undefined),
        error: error,
        inputRef: inputRef,
        onChange: onChange,
        onMouseDown: this.handleInputMouseDown,
        type: "text",
        value: value
      }, inputProps)));
    }
  }]);
  return UICopyInput;
}(_react.PureComponent);

UICopyInput.contextType = _FieldsetContext.FieldsetContext;
UICopyInput.propTypes = {
  autoSelect: _propTypes.default.bool.isRequired,
  buttonProps: _propTypes.default.object,
  defaultValue: _propTypes.default.string,
  error: _propTypes.default.bool,
  inputProps: _propTypes.default.object,
  inputRef: _refObject.default,
  onChange: _propTypes.default.func,
  onCopy: _propTypes.default.func,
  tooltipPlacement: _UICopyButton.default.propTypes.tooltipPlacement,
  value: _propTypes.default.string,
  valueWhenCopied: _propTypes.default.func
};
UICopyInput.defaultProps = {
  autoSelect: true,
  tooltipPlacement: 'bottom'
};
UICopyInput.displayName = 'UICopyInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UICopyInput));

exports.default = _default;
module.exports = exports.default;